<template>
  <div class="mb-20">
    <label class="has-text-weight-bold has-text-grid-1 is-size-14px">
      Documents à télécharger
    </label>
    <button class="button is-fullwidth has-text-weight-bold mt-10 mb-10 is-rounded box-shadow-0"
      @click="getPdf()">
      <b-icon icon="file-pdf" type="is-default" class="mr-10"></b-icon>
      <span class="has-text-default">Recommandation PDF</span>
    </button>
    <button class="button is-fullwidth has-text-weight-bold mb-10 is-rounded box-shadow-0"
      @click="getRecapPdf()">
      <b-icon icon="file-pdf" type="is-default" class="mr-10"></b-icon>
      <span class="has-text-default">Récap budgétaire PDF</span>
    </button>
    <button class="button is-fullwidth has-text-weight-bold mb-10 is-rounded box-shadow-0"
      @click="exportExcel()">
      <b-icon icon="file-excel" type="is-default" class="mr-10"></b-icon>
      <span class="has-text-default">Récap budgétaire Excel</span>
    </button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  methods: {
    ...Recommandation.mapActions({
      actionGetPdf: 'getPdfRecom',
      actionGetRecapPdf: 'getRecapPdfRecom',
      actionGetRecapExcel: 'getRecapExcel',
    }),
    async getPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      await this.actionGetPdf(this.$route.params.id);
      loadingComponent.close();
    },
    async getRecapPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      await this.actionGetRecapPdf(this.$route.params.id);
      loadingComponent.close();
    },
    async exportExcel() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      await this.actionGetRecapExcel(this.$route.params.id);
      loadingComponent.close();
    },
  }
}
</script>

<style>

</style>